import { Logger, getWindow } from '@sitecore-search/common';
export const ENVIRONMENTS = ['dev', 'staging', 'prod', 'uat', 'prodEu', 'apse2'];
const API_DOMAINS = {
    dev: 'https://discover-dev.sitecore-staging.cloud',
    staging: 'https://discover-staging.sitecore-staging.cloud',
    uat: 'https://discover-uat.sitecore-staging.cloud',
    prod: 'https://discover.sitecorecloud.io',
    prodEu: 'https://discover-euc1.sitecorecloud.io',
    apse2: 'https://discover-apse2.sitecorecloud.io',
};
const DEFAULT_SEARCH_PATH = '/discover/v2';
const DEFAULT_EVENT_PATH = '/event/{{key}}/v4/publish';
export const parseCustomerKey = (customerKey) => {
    if (customerKey) {
        const match = customerKey.match(/^(\d+)-(\d+)$/);
        if (match) {
            return [match[1], match[2]];
        }
    }
    return null;
};
let SDKConfig = {
    apiDomain: '',
    apiKey: '',
    customerKey: '',
    domainHash: '',
    domainId: '',
    tokenPath: '/account/1/access-token',
    env: 'prod',
    searchPath: DEFAULT_SEARCH_PATH,
    eventPath: DEFAULT_EVENT_PATH,
    useAccessToken: false,
    userId: null,
    debug: false,
    publicSuffix: false,
};
export const setConfig = (config) => {
    const newConfig = Object.assign({}, SDKConfig, config);
    const { env = 'prod', customerKey } = newConfig;
    if ('useToken' in config && typeof config.useToken !== 'undefined') {
        Logger.warn('Parameter "useToken" has been deprecated');
    }
    if (!customerKey || customerKey !== SDKConfig.customerKey) {
        const customerKeyData = parseCustomerKey(customerKey);
        if (!customerKeyData) {
            throw new Error(`Invalid customerKey: "${customerKey}". It should match the following pattern: (\\d+)-(\\d+). Example: 11111-2222222`);
        }
        const [domainId, domainHash] = customerKeyData;
        Object.assign(newConfig, {
            domainId,
            domainHash,
        }, {
            searchPath: DEFAULT_SEARCH_PATH.replace('{{key}}', newConfig.customerKey),
            eventPath: DEFAULT_EVENT_PATH.replace('{{key}}', newConfig.customerKey),
        });
    }
    if (!env || !ENVIRONMENTS.includes(env)) {
        throw new Error(`Invalid env: "${env}". Expected values: ${ENVIRONMENTS.join(', ')}`);
    }
    SDKConfig = Object.assign(newConfig, {
        apiDomain: API_DOMAINS[env],
    });
};
export const getConfigProperty = (key) => {
    return SDKConfig[key];
};
export const getServiceConfig = () => {
    return SDKConfig;
};
export const setUserId = (userId) => {
    SDKConfig.userId = userId;
};
/**
 * @description: gets the domain to be used to register SDK cookies.
 * if publicSuffix is false (default value) will return only the subdomain to have a cross
 * subdomain cookie.
 * Otherwise, with publicSuffix = true, the full domain will be gathered meaning that cross subdomain
 * cookies are not allowed in this case.
 * e.g:
 * public suffix false, domain = donatello-delta.vercel.app => vercel.app
 * public suffix true, domain = donatello-delta.vercel.app => donatello-delta.vercel.app
 * @return: string with the domain to be used.
 */
export const getDomainHost = () => {
    const currentWindow = getWindow({ location: { hostname: '' } });
    const { publicSuffix } = getServiceConfig();
    if (!publicSuffix) {
        return currentWindow.location.hostname.split('.').reverse().splice(0, 2).reverse().join('.');
    }
    return currentWindow.location.hostname;
};
